import { render, staticRenderFns } from "./InventoryViewReallocation.vue?vue&type=template&id=6f6ef5fe&"
import script from "./InventoryViewReallocation.vue?vue&type=script&lang=ts&"
export * from "./InventoryViewReallocation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports